"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function adjustNumber(value, digits) {
    if (value == null)
        return 0;
    const digitsAdjust = Math.pow(10, digits);
    return Math.round(value * digitsAdjust) / digitsAdjust;
}
exports.default = adjustNumber;
//# sourceMappingURL=adjustNumber.js.map